export default __webpack_public_path__ + "static/disover-cta-back-dd9d8d3eca9eae9327d8c019475edf0a.webp";